<!--详情  -->
<template>
  <div>
    <el-container>
      <el-header class="header">
        <div class="header-wrap">
          <img
            src="@/assets/images/mobile/return.png"
            class="header-img"
            @click="goBack"
          />
        </div>
        <p>{{ metaTitle[type] }}</p>
      </el-header>
      <el-main class="mainContent">
        <div class="main_title">
          <el-divider direction="vertical"></el-divider>
          <span>{{ metaTitle[type] }}</span>
        </div>
        <div v-if="type != 3&&type!=0">
          <!--<div class="lineContent">联系人：{{ formData.sqapplyer }}</div>-->
          <div class="lineContent">联系人：****</div>
          <!--<div class="lineContent">联系方式：{{ formData.phone }}</div>-->
          <div class="lineContent">联系方式：***********</div>
          <div class="lineContent" style="border: none">
            {{ typeinfo(this.type) }}
            <div class="briefCon">
              {{ formData.content }}
            </div>
          </div>
        </div>
        <div v-else-if="type==0">
          <div class="lineContent">联系人：****</div>
          <div class="lineContent">联系方式：***********</div>
          <div class="lineContent" style="border: none">
            {{ typeinfo(this.type) }}
            <div class="briefCon">
              {{ formData.content }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="lineContent">反馈人：{{ formData.recommender }}</div>
          <div class="lineContent">
            反馈人电话：{{ formData.recommenderPhone }}x
          </div>
          <div class="lineContent" style="border: none">
            意见建议：
            <div class="briefCon">
              {{ formData.content }}
            </div>
          </div>
        </div>
        <div style="padding: 20px 0 0 0px">
          <div style="margin-bottom: 1rem">处理流程：</div>
          <el-timeline :reverse="true">
            <el-timeline-item
              placement="top"
              v-for="(activity, index) in activities"
              :key="index"
              :icon="activity.icon"
              :type="activity.type"
              :color="activity.color"
              size="large"
              :timestamp="activity.statusName"
            >
              <!-- <el-card>
                <h4>{{ activity.statusName }}</h4>
                <p>{{ activity.content }}</p>
              </el-card> -->
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: 0,
      metaTitle: [
        "政策咨询",
        "解决问题",
        "需求服务",
        "意见建议",
        "举报投诉",
        "部门评价",
      ],
      activities: [
        // {
        //   type: "primary",
        //   content: "建议上访",
        //   nodename: "大数据处理",
        //   timestamp: "已受理 2018-04-15",
        // },
        // {
        //   type: "primary",
        //   content: "建议上访",
        //   nodename: "政府处理",
        //   timestamp: "受理中 2018-04-13",
        // },
        // {
        //   type: "primary",
        //   content: "建议上访",
        //   nodename: "工商处理",
        //   timestamp: "受理中 2018-04-11",
        // },
        // {
        //   type: "primary",
        //   content: "建议上访",
        //   nodename: "公安处理",
        //   timestamp: "受理中 2018-04-11",
        // },
        // {
        //   color: "#0bbd87",
        //   content: "建议上访",
        //   nodename: "12345处理",
        //   timestamp: "已完结 2018-04-11",
        // },
      ],
      requesturl: "",
      detailsId: "",
      formData: {},
      flowurl:''
    };
  },

  components: {},
  computed: {
    typeinfo() {
      return function (val) {
        let typeinfo = "";
        switch (val) {
          case "0":
            typeinfo = "咨询内容：";
            break;
          case "1":
            typeinfo = "问题内容：";
            break;
          case "2":
            typeinfo = "需求内容：";
            break;
          case "3":
            typeinfo = "意见建议：";
            break;
          case "4":
            typeinfo = "举报投诉内容:";
            break;
          default:
            break;
        }
        return typeinfo;
      };
    },
  },

  created() {
    this.type = this.$route.query.type;
    this.detailsId = this.$route.query.id || "";
    switch (this.type) {
      case "3":
        this.requesturl = `/dev-api/advice/${this.detailsId}`; //意见建议
        this.flowurl="/dev-api/advice/queryTicket"
        break;
      default:
        this.requesturl = `/dev-api/sq_info/${this.detailsId}`;
        this.flowurl="/dev-api/sq_info/queryTicket"
        break;
    }
    this.getList();
    this.getflowList()
  },

  mounted() {},

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getList() {
      this.$httpApi
        .get(
          this.requesturl,
          this.type == "3" ? {} : { title: this.$route.query.title }
        )
        .then((r) => {
          if ((r.code = 200)) {
            this.formData = r.data;
          } else {
            this.$message.error(r.msg);
          }
        })
        .catch((e) => {
          this.$message.error(e.msg);
        });
    },
    getflowList(){
      let params={
        id:this.detailsId,
        pageSize:1000,
        pageNum:1
      }
      this.$httpApi.get(this.flowurl,params).then(r=>{
        if(r.success){
          this.activities=r.data
        }
      }).catch(e=>{

      })
    }
  },
};
</script>
<style lang='scss' scoped>
.header {
  z-index: 100;
  width: 100%;
  height: 5.25rem !important;
  background-color: #36aa60;
  position: relative;
  .header-wrap {
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
    .header-img {
      width: 30px;
      height: 30px;
      margin-top: 1rem;
    }
  }
  p {
    height: 20px;
    text-align: center;
    color: #fff;
    font-size: 22px;
    line-height: 4;
    letter-spacing: 0.5rem;
  }
}
.mainContent {
  padding-top: 0;
  height: calc(100vh - 100px);
  overflow: hidden;
  overflow-y: scroll;
  .main_title {
    height: 80px;
    font-size: 18px;
    span {
      line-height: 80px;
      font-weight: bold;
      letter-spacing: 5px;
    }
  }
  .lineContent {
    padding-left: 20px;
    border-bottom: 1px solid #bbb;
    min-height: 40px;
    line-height: 40px;
    width: calc(95%);
  }
  .briefCon {
    width: 98%;
    text-indent: 1rem;
    line-height: 1.2rem;
    height: 10rem;
    margin: 10px auto;
    overflow-y: auto;
    border: 2px solid #e2e2e2;
    border-radius: 20px;
    padding: 20px;
  }
}

::v-deep {
  .el-divider {
    background-color: #36aa60;
  }
  .el-divider--vertical {
    width: 8px;
    height: 2rem;
  }
}
</style>
